// Modulos
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Guardianes
import { AuthorizationGuard } from './guardianes/authorization.guard';
import { IsLoginGuard } from './guardianes/is-login.guard';
import { IsLogedGuard } from './guardianes/is-loged.guard';

//Interceptores
import { JwtInterceptor } from './interceptores/jwt.interceptor';

// Directivas
import { IsLoginDirective } from './directivas/is-login.directive';

// Servicios
import { SeguridadService } from './servicios/seguridad.service';



@NgModule({
  declarations: [IsLoginDirective],
  imports: [],
  providers: [
    SeguridadService,
    AuthorizationGuard,
    IsLoginGuard,
    IsLogedGuard,
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
  ]
})
export class CoreModule { }
